module.exports = __webpack_public_path__ + "img/check.40b377b9.svg";